import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Products
  getProducts: async (params = {}) => {
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  },
  
  getProduct: async (id) => {
    const response = await axios.get(`${API}/products/${id}`);
    return response.data;
  },
  
  getFeaturedProducts: async () => {
    const response = await axios.get(`${API}/products`, { params: { featured: true } });
    return response.data;
  },
  
  // Categories
  getCategories: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  },
  
  createCategory: async (categoryData, password) => {
    const response = await axios.post(`${API}/categories`, categoryData, { params: { password } });
    return response.data;
  },
  
  deleteCategory: async (categoryId, password) => {
    const response = await axios.delete(`${API}/categories/${categoryId}`, { params: { password } });
    return response.data;
  },
  
  // Reviews
  getReviews: async (productId = null) => {
    const params = productId ? { product_id: productId } : {};
    const response = await axios.get(`${API}/reviews`, { params });
    return response.data;
  },
  
  createReview: async (reviewData) => {
    const response = await axios.post(`${API}/reviews`, reviewData);
    return response.data;
  },
  
  // Site Stats
  getVisitorCount: async () => {
    const response = await axios.get(`${API}/stats/visitors`);
    return response.data;
  },
  
  incrementVisitorCount: async () => {
    const response = await axios.post(`${API}/stats/visitors/increment`);
    return response.data;
  },
  
  getSalesTotal: async () => {
    const response = await axios.get(`${API}/stats/sales`);
    return response.data;
  },
  
  // Artists
  getArtists: async () => {
    const response = await axios.get(`${API}/artists`);
    return response.data;
  },
  
  getArtist: async (id) => {
    const response = await axios.get(`${API}/artists/${id}`);
    return response.data;
  },
  
  // Marketplace Products
  getMarketplaceProducts: async (artistId = null) => {
    const params = artistId ? { artist_id: artistId } : {};
    const response = await axios.get(`${API}/marketplace/products`, { params });
    return response.data;
  },
  
  getMarketplaceProduct: async (id) => {
    const response = await axios.get(`${API}/marketplace/products/${id}`);
    return response.data;
  },
  
  // Orders
  createOrder: async (orderData) => {
    const response = await axios.post(`${API}/orders`, orderData);
    return response.data;
  },
  
  getOrder: async (id) => {
    const response = await axios.get(`${API}/orders/${id}`);
    return response.data;
  },
  
  // Contact
  sendContact: async (contactData) => {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  },
  
  // Seed data
  seedData: async () => {
    const response = await axios.post(`${API}/seed`);
    return response.data;
  },
  
  // Admin API
  adminLogin: async (password) => {
    const response = await axios.post(`${API}/admin/login`, { password });
    return response.data;
  },
  
  adminGetOrders: async (password) => {
    const response = await axios.get(`${API}/admin/orders`, { params: { password } });
    return response.data;
  },
  
  adminUpdateOrderStatus: async (orderId, status, password) => {
    const response = await axios.put(`${API}/admin/orders/${orderId}/status`, { status }, { params: { password } });
    return response.data;
  },
  
  adminGetProducts: async (password) => {
    const response = await axios.get(`${API}/admin/products`, { params: { password } });
    return response.data;
  },
  
  adminCreateProduct: async (productData, password) => {
    const response = await axios.post(`${API}/admin/products`, productData, { params: { password } });
    return response.data;
  },
  
  adminUpdateProduct: async (productId, productData, password) => {
    const response = await axios.put(`${API}/admin/products/${productId}`, productData, { params: { password } });
    return response.data;
  },
  
  adminDeleteProduct: async (productId, password) => {
    const response = await axios.delete(`${API}/admin/products/${productId}`, { params: { password } });
    return response.data;
  },
  
  adminGetArtists: async (password) => {
    const response = await axios.get(`${API}/admin/artists`, { params: { password } });
    return response.data;
  },
  
  adminDeleteArtist: async (artistId, password) => {
    const response = await axios.delete(`${API}/admin/artists/${artistId}`, { params: { password } });
    return response.data;
  },
  
  adminGetStats: async (password) => {
    const response = await axios.get(`${API}/admin/stats`, { params: { password } });
    return response.data;
  },
  
  adminGetContacts: async (password) => {
    const response = await axios.get(`${API}/admin/contacts`, { params: { password } });
    return response.data;
  },
  
  adminDeleteContact: async (contactId, password) => {
    const response = await axios.delete(`${API}/admin/contacts/${contactId}`, { params: { password } });
    return response.data;
  },
  
  adminExportOrders: async (password) => {
    const response = await axios.get(`${API}/admin/orders/export`, { params: { password } });
    return response.data;
  },
  
  // Admin Marketplace Products
  adminGetMarketplaceProducts: async (password) => {
    const response = await axios.get(`${API}/admin/marketplace/products`, { params: { password } });
    return response.data;
  },
  
  adminCreateMarketplaceProduct: async (productData, password) => {
    const response = await axios.post(`${API}/admin/marketplace/products`, productData, { params: { password } });
    return response.data;
  },
  
  adminUpdateMarketplaceProduct: async (productId, productData, password) => {
    const response = await axios.put(`${API}/admin/marketplace/products/${productId}`, productData, { params: { password } });
    return response.data;
  },
  
  adminDeleteMarketplaceProduct: async (productId, password) => {
    const response = await axios.delete(`${API}/admin/marketplace/products/${productId}`, { params: { password } });
    return response.data;
  },
  
  // Admin Artist Management
  adminCreateArtist: async (artistData, password) => {
    const response = await axios.post(`${API}/admin/artists`, artistData, { params: { password } });
    return response.data;
  },
  
  adminUpdateArtist: async (artistId, artistData, password) => {
    const response = await axios.put(`${API}/admin/artists/${artistId}`, artistData, { params: { password } });
    return response.data;
  },

  // File Upload
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Shipping Rates (Shippo)
  getShippingRates: async (address, cartItems) => {
    const response = await axios.post(`${API}/shipping/rates`, {
      address: {
        name: `${address.first_name} ${address.last_name}`,
        street1: address.address,
        street2: "",
        city: address.city,
        state: address.state,
        zip_code: address.zip_code,
        country: "US"
      },
      cart_items: cartItems.map(item => ({
        product_id: item.product.id,
        quantity: item.quantity,
        is_marketplace: item.isMarketplace || false,
        // Include shipping overrides if present (for variable shipping like magnets)
        ship_weight: item.product.ship_weight || null,
        ship_length: item.product.ship_length || null,
        ship_width: item.product.ship_width || null,
        ship_height: item.product.ship_height || null
      }))
    });
    return response.data;
  },

  // Settings
  getPurchaseNotificationSetting: async () => {
    const response = await axios.get(`${API}/stats/settings/purchase-notification`);
    return response.data;
  },

  setPurchaseNotificationSetting: async (enabled) => {
    const response = await axios.post(`${API}/stats/settings/purchase-notification?enabled=${enabled}`);
    return response.data;
  },

  // Subscribers
  subscribe: async (email) => {
    const response = await axios.post(`${API}/subscribers`, { email });
    return response.data;
  },

  getSubscribers: async () => {
    const response = await axios.get(`${API}/subscribers`);
    return response.data;
  },

  getSubscriberCount: async () => {
    const response = await axios.get(`${API}/subscribers/count`);
    return response.data;
  },

  markSubscribersSeen: async () => {
    const response = await axios.post(`${API}/subscribers/mark-seen`);
    return response.data;
  },

  deleteSubscriber: async (id) => {
    const response = await axios.delete(`${API}/subscribers/${id}`);
    return response.data;
  },

  // Company Gallery
  getGalleryPhotos: async () => {
    const response = await axios.get(`${API}/gallery`);
    return response.data;
  },

  addGalleryPhoto: async (photoData, password) => {
    const response = await axios.post(`${API}/gallery`, photoData, { params: { password } });
    return response.data;
  },

  updateGalleryPhoto: async (photoId, photoData, password) => {
    const response = await axios.put(`${API}/gallery/${photoId}`, photoData, { params: { password } });
    return response.data;
  },

  deleteGalleryPhoto: async (photoId, password) => {
    const response = await axios.delete(`${API}/gallery/${photoId}`, { params: { password } });
    return response.data;
  },

  // Discount Codes
  getDiscountCodes: async (password) => {
    const response = await axios.get(`${API}/discounts`, { params: { password } });
    return response.data;
  },

  createDiscountCode: async (codeData, password) => {
    const response = await axios.post(`${API}/discounts`, codeData, { params: { password } });
    return response.data;
  },

  updateDiscountCode: async (codeId, codeData, password) => {
    const response = await axios.put(`${API}/discounts/${codeId}`, codeData, { params: { password } });
    return response.data;
  },

  deleteDiscountCode: async (codeId, password) => {
    const response = await axios.delete(`${API}/discounts/${codeId}`, { params: { password } });
    return response.data;
  },

  validateDiscountCode: async (code, email, subtotal) => {
    const response = await axios.post(`${API}/discounts/validate`, { code, email, subtotal });
    return response.data;
  },

  applyDiscountCode: async (code, email, subtotal) => {
    const response = await axios.post(`${API}/discounts/apply`, { code, email, subtotal });
    return response.data;
  },

  getDiscountStats: async (password) => {
    const response = await axios.get(`${API}/discounts/stats`, { params: { password } });
    return response.data;
  },

  // BTO (Built-to-Order) Orders
  createBTOOrder: async (orderData) => {
    const response = await axios.post(`${API}/bto`, orderData);
    return response.data;
  },

  getBTOOrders: async () => {
    const response = await axios.get(`${API}/bto`);
    return response.data;
  },

  getBTOOrder: async (id) => {
    const response = await axios.get(`${API}/bto/${id}`);
    return response.data;
  },

  updateBTOOrder: async (orderId, updateData) => {
    const response = await axios.put(`${API}/bto/${orderId}`, updateData);
    return response.data;
  },

  deleteBTOOrder: async (orderId) => {
    const response = await axios.delete(`${API}/bto/${orderId}`);
    return response.data;
  },

  getBTOStats: async () => {
    const response = await axios.get(`${API}/bto/stats`);
    return response.data;
  },

  getBTOShippingRates: async (address, product, quantity = 1) => {
    const response = await axios.post(`${API}/shipping/rates`, {
      address: {
        name: `${address.first_name} ${address.last_name}`,
        street1: address.address,
        street2: "",
        city: address.city,
        state: address.state,
        zip_code: address.zip_code,
        country: "US"
      },
      cart_items: [{
        product_id: product.id,
        quantity: quantity,
        is_marketplace: false,
        ship_weight: product.ship_weight || null,
        ship_length: product.ship_length || null,
        ship_width: product.ship_width || null,
        ship_height: product.ship_height || null
      }]
    });
    return response.data;
  },
};
